import React from 'react';
import Component from '../MgyComponent';
import {Form, FormElement} from "@progress/kendo-react-form";

export const FormTemplate = ({children, handlerSubmit, className, ...args}) =>
    <Form onSubmit = { (data) => handlerSubmit(data) }
          {...args}
          className = {className + " mgy-centered "}
          render ={ (formRenderProps) => (
                <FormElement className={"input-field"}>
                    { children }
                </FormElement>
            )} />;

export default function MgyForm({handlerSubmit, children, ...rest}) {
    return (
        <Component tpl={ FormTemplate } handlerSubmit={ handlerSubmit } {...rest}>
            { children }
        </Component>
    );
};
